import './SimulationButton.css';
import { t } from '../../copy/strings';
import { toggleAbout } from '../../state/actions';
import { useIsSimulated, useTvOn, useUi } from '../../state/hooks';

/**
 * Botão "Simulação" (§6.9): só em simulação (`isSimulated`, vale também no replay) e nunca na TV (lá o aviso é a
 * faixa). Abre o `AboutDialog` na variante simulação; um 2º clique fecha.
 */
export function SimulationButton() {
  const sim = useIsSimulated();
  const tv = useTvOn();
  const ui = useUi();
  if (!sim || tv) return null;
  return (
    <button
      type="button"
      class="simulation-button"
      data-testid="simulation-button"
      data-about-trigger="simulation"
      aria-haspopup="dialog"
      aria-expanded={ui.aboutOpen === 'simulation' ? 'true' : 'false'}
      aria-controls="about-dialog"
      onClick={() => toggleAbout('simulation')}
    >
      {t('sim.button')}
    </button>
  );
}
